<template>
  <div class="bg-black py-2 grid grid-cols-7 h-[60px] md:h-[70px] w-full">
    <div class="px-3 col-span-2">
      <img src="@/assets/allhouse-white.svg" class="hidden md:flex h-fit" />
      <img
        src="@/assets/allhouse_white_flag_transparent.png"
        class="flex md:hidden w-10"
      />
    </div>
    <div class="col-span-3">
      <button
        class="text-white text-base px-3 py-2 border-white rounded-full border-[1px] w-full hover:text-black hover:bg-white transition-all"
        @click="searchOpen = !searchOpen"
      >
        Search <fa-icon icon="search" />
      </button>
    </div>
    <div class="px-3 col-span-2 grid grid-cols-1 md:grid-cols-2">
      <button>
        <a
          href="https://dashboard.allhouse.co.nz"
          class="py-2 px-3 text-center text-white text-base hidden md:block"
          >Managers Portal</a
        >
      </button>
      <button
        class="text-white text-base px-3 py-2"
        v-if="!userToken"
        @click="showAuthModal = true"
      >
        Sign In
      </button>
      <button v-else class="text-white text-base px-3 py-2" @click="logout">
        Logout
      </button>
    </div>
  </div>
  <div
    class="bg-white text-3xl max-h-0 transition-max-height duration-500 ease-in-out overflow-hidden"
    v-bind:class="{ 'max-h-[900px]': searchOpen, 'h-fit': searchOpen }"
  >
    <div
      class="w-full md:w-1/2 mx-auto px-3 grid grid-cols-1 md:grid-cols-2 text-base gap-4 py-5"
    >
      <div>
        <label>Region</label>
        <select
          v-model="selectedRegion"
          class="appearance-none bg-white text-black border-gray-500 border-[1px] rounded-md py-2 px-3 w-full"
        >
          <option :value="null">All New Zealand</option>
          <option v-for="region of regions" :key="region.name" :value="region">
            {{ region.name }}
          </option>
        </select>
      </div>
      <div>
        <label>District</label>
        <select
          v-model="selectedDistrict"
          :disabled="!selectedRegion"
          class="appearance-none bg-white text-black border-gray-500 border-[1px] rounded-md py-2 px-3 w-full"
        >
          <option :value="null">All Districts</option>
          <option
            v-for="district of districts"
            :key="district.name"
            :value="district"
          >
            {{ district.name }}
          </option>
        </select>
      </div>
      <div>
        <label>Suburb</label>
        <select-dropdown
          v-model="selectedSuburbs"
          :options="suburbs"
          :multiple="true"
          no-selection-label="All Suburbs"
        />
      </div>
      <div>
        <label>Price</label>
        <div class="w-full grid grid-cols-2 gap-4">
          <div class="grid grid-cols-5 border-[1px] border-gray-500 rounded-md">
            <div
              class="border-r-[1px] border-gray-500 border-solid text-center py-2 cursor-pointer hover:bg-black hover:text-white"
              @click="updateMinPrice(-50)"
            >
              <fa-icon icon="minus" />
            </div>
            <div class="col-span-3 py-2 text-center">${{ priceRange[0] }}</div>
            <div
              class="border-l-[1px] border-gray-500 border-solid text-center py-2 cursor-pointer hover:bg-black hover:text-white"
              @click="updateMinPrice(50)"
            >
              <fa-icon icon="plus" />
            </div>
          </div>
          <div class="grid grid-cols-5 border-[1px] border-gray-500 rounded-md">
            <div
              class="border-r-[1px] border-gray-500 border-solid text-center py-2 cursor-pointer hover:bg-black hover:text-white"
              @click="updateMaxPrice(-50)"
            >
              <fa-icon icon="minus" />
            </div>
            <div class="col-span-3 py-2 text-center">${{ priceRange[1] }}</div>
            <div
              class="border-l-[1px] border-gray-500 border-solid text-center py-2 cursor-pointer hover:bg-black hover:text-white"
              @click="updateMaxPrice(50)"
            >
              <fa-icon icon="plus" />
            </div>
          </div>
        </div>
      </div>
      <div>
        <label>Bedrooms</label>
        <div class="grid grid-cols-5 border-[1px] border-gray-500 rounded-md">
          <div
            class="border-r-[1px] border-gray-500 border-solid text-center py-2 cursor-pointer hover:bg-black hover:text-white"
            @click="bedrooms = bedrooms - 1 >= 0 ? bedrooms - 1 : bedrooms"
          >
            <fa-icon icon="minus" />
          </div>
          <div class="col-span-3 py-2 text-center">
            {{ bedrooms > 0 ? `${bedrooms}+` : "Any" }}
          </div>
          <div
            class="border-l-[1px] border-gray-500 border-solid text-center py-2 cursor-pointer hover:bg-black hover:text-white"
            @click="bedrooms += 1"
          >
            <fa-icon icon="plus" />
          </div>
        </div>
      </div>
      <div>
        <label>Bathrooms</label>
        <div class="grid grid-cols-5 border-[1px] border-gray-500 rounded-md">
          <div
            class="border-r-[1px] border-gray-500 border-solid text-center py-2 cursor-pointer hover:bg-black hover:text-white"
            @click="bathrooms = bathrooms - 1 >= 0 ? bathrooms - 1 : bathrooms"
          >
            <fa-icon icon="minus" />
          </div>
          <div class="col-span-3 py-2 text-center">
            {{ bathrooms > 0 ? `${bathrooms}+` : "Any" }}
          </div>
          <div
            class="border-l-[1px] border-gray-500 border-solid text-center py-2 cursor-pointer hover:bg-black hover:text-white"
            @click="bathrooms += 1"
          >
            <fa-icon icon="plus" />
          </div>
        </div>
      </div>
      <div class="md:col-span-2">
        <button
          type="button"
          class="bg-black text-white uppercase px-3 py-2 w-full"
          @click="search"
        >
          search
        </button>
      </div>
      <div class="md:col-span-2">
        <button
          type="button"
          class="bg-gray-200 text-black uppercase px-3 py-2 w-full"
          @click="searchOpen = false"
        >
          close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useSessionStore } from "@/store/session";
import { mapState, mapWritableState } from "pinia";
import { useListingStore } from "@/store/listing";
import SelectDropdown from "@/components/SelectDropdown";
export default {
  name: "NavBar",
  components: { SelectDropdown },
  data: () => ({
    searchOpen: false,
  }),
  computed: {
    ...mapState(useSessionStore, ["userToken"]),
    ...mapState(useListingStore, ["regions"]),
    ...mapWritableState(useListingStore, [
      "selectedRegion",
      "selectedDistrict",
      "selectedSuburbs",
      "priceRange",
      "bedrooms",
      "bathrooms",
    ]),
    ...mapWritableState(useSessionStore, ["showAuthModal"]),
    districts() {
      if (!this.selectedRegion) return [];
      return this.selectedRegion.districts;
    },
    suburbs() {
      if (!this.selectedDistrict) return [];
      return this.selectedDistrict.suburbs;
    },
  },
  methods: {
    logout() {
      localStorage.removeItem("userId");
      localStorage.removeItem("userToken");
      window.location.reload();
    },
    async search() {
      await useListingStore().getSearchResults();
      this.searchOpen = false;
      this.$gtag.event("search", {
        event_category: "listings",
        event_label: "A new listings search has been performed",
        value: `region:${this.selectedRegion.name}-district:${
          this.selectedDistrict.name
        }-suburb:${this.selectedSuburbs.toString()}`,
      });
    },
    updateMinPrice(val) {
      if (
        this.priceRange[0] + val < 0 ||
        this.priceRange[0] + val >= this.priceRange[1]
      )
        return;
      this.priceRange[0] += val;
    },
    updateMaxPrice(val) {
      if (
        this.priceRange[1] + val <= this.priceRange[0] ||
        this.priceRange[1] + val > 2000
      )
        return;
      this.priceRange[1] += val;
    },
  },
};
</script>

<style scoped></style>
